import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  navbar: {
    backgroundColor: '#EFEFEF',
    [theme.breakpoints.up('md')]: {
      marginBottom: '3rem',
      paddingTop: '32px'
    },
    [theme.breakpoints.down('sm')]: {
      paddingTop: '1rem',
      marginBottom: '1.875rem'
    }
  },
  logoContainer: {
    cursor: 'pointer'
  },
  poweredByLogo: {
    width: '9.75rem',
    height: '1.375rem',
    [theme.breakpoints.up('md')]: {
      marginRight: '3.25rem'
    },
    [theme.breakpoints.only('sm')]: {
      marginRight: '3.25rem'
    },
    [theme.breakpoints.down('xs')]: {
      paddingRight: '0.5rem'
    }
  },
  searchBoxContainerDownSm: {
    marginTop: '1rem',
    marginBottom: '1rem'
  },
  drawerContainer: {
    [theme.breakpoints.up('md')]: {
      marginRight: '-8px',
      marginBottom: '16px'
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: '-8px',
      paddingTop: '24px'
    }
  },
  locationContainer: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: '1.3125rem'
    },
    [theme.breakpoints.only('sm')]: {
      paddingLeft: '1.3125rem'
    },
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '0.5rem'
    }
  }
}));

export default useStyles;
